module.exports = __webpack_public_path__ + "static/media/territorio-digital-main.1cdc6909.png";